module.exports = __webpack_public_path__ + "img/solutionBanner1.53c407d6.png";